module.exports = __webpack_public_path__ + "img/food-14.de167cdf.jpg";